var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLioOrb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_5811)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 20.0001,
    r: 19.5,
    fill: "url(#paint0_radial_659_5811)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1094 29.6769C21.1456 29.6448 21.1819 29.6128 21.2184 29.5811C21.2199 29.5798 21.2214 29.5785 21.2229 29.5772C23.1002 27.9477 25.3975 26.908 27.8369 26.5803C27.9799 26.561 28.1234 26.5443 28.2674 26.53L28.3993 26.5169C28.4507 26.5118 28.5003 26.5009 28.5475 26.4848C28.8166 26.3932 29.007 26.1342 29.007 25.8333V15.3333C29.007 14.954 28.7058 14.6466 28.3342 14.6466H25.3756L24.8106 14.3911C23.0771 13.6072 21.5949 12.3407 20.534 10.7368L19.5671 9.27515L18.6002 10.7368C17.5393 12.3407 16.0571 13.6072 14.3236 14.3911L13.7586 14.6466H10.9112C10.5395 14.6466 10.2383 14.954 10.2383 15.3333V25.8333C10.2383 26.1342 10.4287 26.3932 10.6978 26.4848C10.745 26.5009 10.7946 26.5118 10.846 26.5169L10.9779 26.53C11.1219 26.5443 11.2654 26.561 11.4084 26.5803C13.8478 26.908 16.1451 27.9477 18.0224 29.5772L18.0263 29.5807C18.063 29.6125 18.0995 29.6446 18.1359 29.6769L19.1252 30.5563C19.1651 30.5917 19.2084 30.6218 19.2539 30.6462C19.3675 30.7072 19.4957 30.7335 19.6227 30.7228C19.7497 30.7335 19.8778 30.7072 19.9914 30.6462C20.037 30.6218 20.0802 30.5917 20.1201 30.5563L21.1094 29.6769ZM21.6968 27.4973C21.4885 27.6383 21.2836 27.785 21.0824 27.9375C20.8328 28.1266 20.5889 28.3245 20.3511 28.5309V20.2063L20.534 19.9298C21.5949 18.3259 23.0771 17.0594 24.8106 16.2755L25.3755 16.0201H27.6613V25.2185C25.5233 25.5057 23.4841 26.2877 21.6968 27.4973ZM23.6263 15.3333C22.0132 14.4781 20.6208 13.2416 19.5671 11.7244C18.5134 13.2416 17.121 14.4781 15.5079 15.3333C17.121 16.1885 18.5134 17.425 19.5671 18.9422C20.6208 17.425 22.0132 16.1885 23.6263 15.3333ZM18.8943 20.3743L18.6002 19.9298C17.5393 18.3259 16.0571 17.0594 14.3236 16.2755L13.7587 16.0201H11.584V25.2185C11.6078 25.2217 11.6315 25.2249 11.6552 25.2282C13.7672 25.5231 15.781 26.3011 17.5485 27.4973C18.0152 27.8131 18.4647 28.158 18.8943 28.5309V20.3743Z",
    fill: "url(#paint1_linear_659_5811)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6968 27.4972C21.4884 27.6382 21.2835 27.785 21.0823 27.9375C20.8328 28.1266 20.5888 28.3245 20.351 28.5309V20.2062L20.5339 19.9297C21.5949 18.3258 23.077 17.0594 24.8106 16.2755L25.3754 16.02H27.6613V25.2184C25.5233 25.5056 23.4841 26.2877 21.6968 27.4972ZM23.6262 15.3332C22.0131 14.478 20.6208 13.2415 19.5671 11.7244C18.5134 13.2415 17.121 14.478 15.5079 15.3332C17.121 16.1884 18.5134 17.425 19.5671 18.9421C20.6208 17.425 22.0131 16.1884 23.6262 15.3332ZM18.8942 20.3742L18.6002 19.9297C17.5392 18.3258 16.0571 17.0594 14.3235 16.2755L13.7587 16.02H11.584V25.2184C11.6077 25.2216 11.6314 25.2249 11.6551 25.2282C13.7672 25.523 15.781 26.3011 17.5485 27.4972C18.0151 27.813 18.4646 28.158 18.8942 28.5309V20.3742Z",
    fill: "#0C1119"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.5863,
    cy: 5.14057,
    rx: 16.3313,
    ry: 12.5068,
    transform: "rotate(-22.4914 11.5863 5.14057)",
    fill: "url(#paint2_radial_659_5811)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_659_5811",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5 21.7064) rotate(90) scale(27.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.599002,
    stopColor: "#1E245C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E87FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_659_5811",
    x1: 6.07772,
    y1: 18.5208,
    x2: 32.9364,
    y2: 18.5208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29D8E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6E87FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F75DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_659_5811",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5863 1.43486) rotate(-90) scale(8.80107 11.4924)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A5C1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5265FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_5811"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.0703125,
    y: 0.500122,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLioOrb);
export default __webpack_public_path__ + "static/media/lio-orb.c9ccd7e4b5fc3d2d64518a46bd1895a7.svg";
export { ForwardRef as ReactComponent };